import { render, staticRenderFns } from "./PayoutComponent.vue?vue&type=template&id=2bdbaefb&"
import script from "./PayoutComponent.vue?vue&type=script&lang=js&"
export * from "./PayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports